import { render, staticRenderFns } from "./seccional.vue?vue&type=template&id=075f711e&scoped=true&"
import script from "./seccional.vue?vue&type=script&lang=js&"
export * from "./seccional.vue?vue&type=script&lang=js&"
import style0 from "./seccional.vue?vue&type=style&index=0&id=075f711e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f711e",
  null
  
)

export default component.exports